import { SCOPES } from '@/features/config/scopes';

// The form field configs this page edits
export const CONFIG_TYPE = 'client';

export const SCOPE_TABS = [
	{ label: 'Default', value: SCOPES.DEFAULT },
	{ label: 'Ledger', value: SCOPES.LEDGER },
	{ label: 'Broker group', value: SCOPES.BROKER_GROUP },
];

// The settings admins edit: the backend's ADMIN_EDITABLE_FIELDS, less order (not shown here)
export const EDITABLE_FIELDS = ['label', 'helperText', 'description', 'mandatory', 'visible'];

/** Whether a { scope, scopeId } is complete enough to list: the default, or one with an id. */
export const isScopeChosen = ({ scope, scopeId }) => scope === SCOPES.DEFAULT || Boolean(scopeId);
